<div class="data-lakes-tab-container">
    <div class="table-container">
        <div class="table-header">
            <h2 class="table-title">Data Lakes</h2>
            <button mat-fab extended class="add-button" 
                    matTooltip="Add new data lake/s"
                    [disabled]="dataStoreService.isDataLakeLoading()"
                    (click)="openAddDataLakeDialog()"
            ><mat-icon>add</mat-icon>Add Data Lake</button>
        </div>
        <div class="table-body">
            @if (dataStoreService.isDataLakeLoading()) {
                <app-loading-spinner/>
            } @else if (dataStoreService.dataLakesErrorMessage() === "") { 
                <table mat-table [dataSource]="dataLakesDataSource" matSort #dataLakeSort="matSort" class="table">
                    <ng-container matColumnDef="storeName" class="store-name-column">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-header">Name</th>
                        <td mat-cell *matCellDef="let element">{{element.storeName}}</td>
                    </ng-container>

                    <ng-container matColumnDef="creationDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-header">Date Created</th>
                        <td mat-cell *matCellDef="let element" class="creation-date-column">
                            @if (element.createDateTimeUtc) {
                                {{element.createDateTimeUtc | date:'dd MMM yyyy, HH:mm'}}
                            } @else {
                                <span class="empty-table-field">{{"-"}}</span>
                            }
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="provisionStatusTypeId">
                        <th mat-header-cell *matHeaderCellDef class="column-header"></th>
                        <td mat-cell *matCellDef="let element" class="status-column">
                            <div class="icon-container">
                                @if (element.provisionStatusTypeId === provisionStatusEnum.Created) {
                                    <span matTooltip="Editing not yet avaliable" matTooltipDisabled="false">
                                        <button disabled mat-icon-button
                                            class="edit-button">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                    </span>
                                } @else if (element.provisionStatusTypeId === provisionStatusEnum.Creating) {
                                    <div class="loading"><app-loading-spinner [strokeWidth]="2" [diameter]="25"></app-loading-spinner></div>
                                } @else if (element.provisionStatusTypeId === provisionStatusEnum.Errored) {
                                    <button disabled mat-icon-button
                                        class="error-button">
                                        <mat-icon>error_outline</mat-icon>
                                    </button>
                                }
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columns ; sticky: true" class="header-row"></tr>
                    <tr mat-row *matRowDef="let row; columns: columns;" class="row"></tr>

                    <tr class="full-row" *matNoDataRow>
                        <td [attr.colspan]="columns.length" class="full-row-cell">
                            <div class="full-row-content">
                                <mat-icon>info</mat-icon>
                                <p class="not-found-message">No Data Lakes Found</p>
                                <p class="not-found-sub-message">To create a data lake, click Add Data Lake</p>
                            </div>
                        </td>
                    </tr>
                </table>
            } @else {
                <tr class="error-container">
                    <mat-icon>warning</mat-icon>
                    <p class="error-message">Error: {{dataStoreService.dataLakesErrorMessage()}}</p>
                </tr>
            }
        </div>
    </div>

    <div class="table-container">
        <div class="table-header">
            <h2 class="table-title">Landing Zones</h2>
            <button mat-fab extended class="add-button" 
                    matTooltip="Add new landing zone/s"
                    [disabled]="dataStoreService.isLandingZoneLoading()"
                    (click)="openAddLandingZoneDialog()"
            ><mat-icon>add</mat-icon>Add Landing Zone</button>
        </div>
        <div class="table-body">
            @if (dataStoreService.isLandingZoneLoading()) {
                <app-loading-spinner/>
            } @else if (dataStoreService.landingZonesErrorMessage() === '') {  
                <table mat-table [dataSource]="landingZonesDataSource" matSort #landingZoneSort="matSort" class="table">
                    <ng-container matColumnDef="storeName" class="store-name-column">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-header">Name</th>
                        <td mat-cell *matCellDef="let element">{{element.storeName}}</td>
                    </ng-container>

                    <ng-container matColumnDef="creationDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-header">Date Created</th>
                        <td mat-cell *matCellDef="let element" class="creation-date-column">
                            @if (element.createDateTimeUtc) {
                                {{element.createDateTimeUtc | date:'dd MMM yyyy, HH:mm'}}
                            } @else {
                                <span class="empty-table-field">{{"-"}}</span>
                            }
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="provisionStatusTypeId">
                        <th mat-header-cell *matHeaderCellDef class="column-header"></th>
                        <td mat-cell *matCellDef="let element" class="status-column">
                            <div class="icon-container">
                                @if (element.provisionStatusTypeId === provisionStatusEnum.Created) {
                                    <span matTooltip="Editing not yet avaliable" matTooltipDisabled="false">
                                        <button disabled mat-icon-button
                                            class="edit-button">
                                            <mat-icon class="edit-icon">edit</mat-icon>
                                        </button>
                                    </span>
                                } @else if (element.provisionStatusTypeId === provisionStatusEnum.Creating) {
                                    <div class="loading"><app-loading-spinner [strokeWidth]="2" [diameter]="25"></app-loading-spinner></div>
                                } @else if (element.provisionStatusTypeId === provisionStatusEnum.Errored) {
                                    <button disabled mat-icon-button
                                        class="error-button">
                                        <mat-icon>error_outline</mat-icon>
                                    </button>
                                }
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columns ; sticky: true" class="header-row"></tr>
                    <tr mat-row *matRowDef="let row; columns: columns;" class="row"></tr>

                    <tr class="full-row" *matNoDataRow>
                        <td [attr.colspan]="columns.length" class="full-row-cell">
                            <div class="full-row-content">
                                <mat-icon>info</mat-icon>
                                <p class="not-found-message">No Landing Zones Found</p>
                                <p class="not-found-sub-message">To create a landing zone, click Add Landing Zone</p>
                            </div>
                        </td>
                    </tr>
                </table>
            } @else {
                <tr class="error-container">
                    <mat-icon>warning</mat-icon>
                    <p class="error-message">Error: {{dataStoreService.landingZonesErrorMessage()}}</p>
                </tr>
            }
        </div>
    </div>

</div>
